import { CardString } from 'pokersolver'
import { ActionHint, BoardStateTag, Player, PlayerStates, Snapshot } from '@ppwr/poker'

import MyFirstGameStepNames from './MyFirstGameStepNames'

export type MyFirstGameStep = {
  internalName?: MyFirstGameStepNames
  stepperNumber: number
  configureGame?: (user: { _id: string; name: string }) => Snapshot
}

export const excludeFromStepper: MyFirstGameStepNames[] = [
  MyFirstGameStepNames.default,
  MyFirstGameStepNames.faceUpNote,
  MyFirstGameStepNames.forcedBets,
  MyFirstGameStepNames.smallBlind,
  MyFirstGameStepNames.bigBlind,
  MyFirstGameStepNames.handRankingsNote,
  MyFirstGameStepNames.preFlopStrategy,
  MyFirstGameStepNames.petraRaises1,
  MyFirstGameStepNames.leslieCalls1,
  MyFirstGameStepNames.firstRoundFinished,
  MyFirstGameStepNames.petraBets2,
  MyFirstGameStepNames.estherCalls2,
  MyFirstGameStepNames.estherChecks2,
  MyFirstGameStepNames.leslieFolds,
  MyFirstGameStepNames.estherFolds,
  MyFirstGameStepNames.secondRoundFinished,
  MyFirstGameStepNames.petraBets3,
  MyFirstGameStepNames.thirdRoundFinished,
  MyFirstGameStepNames.petraBets4,
  MyFirstGameStepNames.fourthRoundFinished,
  MyFirstGameStepNames.beforeWinnerNote,
  MyFirstGameStepNames.endCard
]
export const stagesWhereCallIsEnabled: MyFirstGameStepNames[] = [
  MyFirstGameStepNames.userTurnCall1,
  MyFirstGameStepNames.userTurnCall2,
  MyFirstGameStepNames.userTurnCall3,
  MyFirstGameStepNames.userTurnCall4
]
export const automaticStages: MyFirstGameStepNames[] = [
  MyFirstGameStepNames.smallBlind,
  MyFirstGameStepNames.bigBlind,
  MyFirstGameStepNames.petraRaises1,
  MyFirstGameStepNames.leslieCalls1,
  MyFirstGameStepNames.estherCalls2,
  MyFirstGameStepNames.estherChecks2,
  MyFirstGameStepNames.firstRoundFinished,
  MyFirstGameStepNames.petraBets2,
  MyFirstGameStepNames.estherFolds,
  MyFirstGameStepNames.leslieFolds,
  MyFirstGameStepNames.secondRoundFinished,
  MyFirstGameStepNames.petraBets3,
  MyFirstGameStepNames.thirdRoundFinished,
  MyFirstGameStepNames.petraBets4,
  MyFirstGameStepNames.fourthRoundFinished,
  MyFirstGameStepNames.beforeWinnerNote
]
export const stagesWithNextStepFloatingButton: MyFirstGameStepNames[] = [
  MyFirstGameStepNames.letsBegin,
  MyFirstGameStepNames.holeAndCommunityCards,
  MyFirstGameStepNames.rounds,
  MyFirstGameStepNames.roles,
  MyFirstGameStepNames.preFlopRoundNote,
  MyFirstGameStepNames.theFlop,
  MyFirstGameStepNames.theTurn,
  MyFirstGameStepNames.theRiver,
  MyFirstGameStepNames.theShowdown
]

export const MyFirstGameCommunityCards = (stage: BoardStateTag): CardString[] => {
  const communityCards = ['Qc', '4d', 'Th', '8d', 'Js']

  if (stage === 'flop') {
    return communityCards.slice(0, 3) as CardString[]
  }

  if (stage === 'turn') {
    return communityCards.slice(0, 4) as CardString[]
  }

  if (stage === 'river') {
    return communityCards.slice(0, 5) as CardString[]
  }

  return [] as CardString[]
}

export const getMyFirstGamePlayers = ({ _id, name }: { _id: string; name: string }) => {
  const claudia = new Player('Claudia', 10000, 'claudia', [], undefined, undefined, 'claudia')
  claudia.role = 'SB'
  claudia.state = PlayerStates.InPlay
  claudia.cards = ['3d', '5h']

  const player = new Player(name, 10000, _id, [], undefined, undefined, _id)
  player.state = PlayerStates.InPlay
  player.cards = ['Jh', 'Jd']
  player.actions = [ActionHint.RAISE, ActionHint.CALL, ActionHint.FOLD]
  player.role = 'D'

  const esther = new Player('Esther', 10000, 'esther', [], undefined, undefined, 'esther')
  esther.state = PlayerStates.InPlay
  esther.cards = ['As', 'Tc']
  esther.role = 'BB'

  const leslie = new Player('Leslie', 10000, 'leslie', [], undefined, undefined, 'leslie')
  leslie.state = PlayerStates.InPlay
  leslie.cards = ['6h', '7h']

  const petra = new Player('Petra', 10000, 'petra', [], undefined, undefined, 'petra')
  petra.state = PlayerStates.InPlay
  petra.cards = ['Kc', 'Qs']

  return {
    claudia,
    player,
    esther,
    leslie,
    petra
  }
}
